module.exports = __webpack_public_path__ + "img/wordOfTheDay.668adea2.svg";